export default "__VITE_ASSET__a966a0f1__"